<template>
  <div class="infosHautes">
    <router-link :to="$route.path.replace(('/detail/'+value.id),'')" v-slot="{ href, route, navigate}">
        <a :href="href" @click="navigate" class="nav-link text-gray bold">< {{ $i18n.t("Revenir à la liste des évaluations") }}</a>
    </router-link>
    <span class="badged">Ref : {{value.reference}}</span>
    <span class="adresse">{{ value.adresse }}, {{ value.code_postal }} {{ value.ville }}</span>
    <span class="type"> - {{ $t(value.type_bien) }}</span>
  </div>
</template>

<script>
export default {
  name: 'EvaluationSumLine',
  components: {},
  data() {
    return {
      nodata:this.$i18n.t('Données insuffisantes'),
    }
  },
  props:{
    value: Object,
    rights: Object,
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
  mounted(){
  }
}
</script>